import { isNativeAppBoth } from './userAgentUtil';

// [ServerSide] 디바이스 조회
export const getSsrDeviceValue = (
  userAgent: string | null
): 'Android' | 'iOS' | 'PC' | 'MO' => {
  const target = userAgent || '';
  const isMobile = /iPhone|iPad|iPod|Android/i.test(target);

  if (isMobile || isNativeAppBoth(target)) {
    if (/android/i.test(target)) {
      return 'Android';
    }
    if (/iPad|iPhone|iPod/.test(target)) {
      return 'iOS';
    }
    return 'MO';
  }
  return 'PC';
};
